import Holdbacks from "./PaymentOrderHoldbacks"
import { usePaymentOrder } from "../../components/context/PaymentOrderContext"
import Items from "./PaymentOrderItems"
import PaymentMethod from "./PaymentOrderMethod"

const PaymentOrders = () => {

    const { stepMovement } = usePaymentOrder()
    const renderStep = () => {
        switch (stepMovement?.stepIndex) {
            case 0:
                return <Items/>
            case 1:
                return <Holdbacks />
            case 2:
                return <PaymentMethod/>
        }
    }

    return (
        <div className="px-2 py-2 flex flex-column h-full">
            {renderStep()}
        </div>
    )
}


export default PaymentOrders
